<h3 class="with-manual-link">
  <span i18n="@@voice-bot">Audio-Bot</span>
  <app-manual-link
    href="https://reflact.github.io/engine/Handbuch/Nutzeroberfläche/Bot-Verwaltung/Allgemein/Konfiguration/Voice-Bot"
  ></app-manual-link>
</h3>
<app-submenu [items]="this.submenuService.SUBMENU_FOR_CONFIGURATION"></app-submenu>

<app-form-for-boolean
  [label]="this.showPrompt"
  [(value)]="this.rss.botConfig.promptbarAudioActive"
  [colClass]="'col-3'"
  (valueChange)="this.rss.saveBotConfigField('promptbarAudioActive');"
></app-form-for-boolean>
<h3
  class="mt-5"
  i18n="@@prompt-options"
>Eingabezeile</h3>
<app-form-for-boolean
  [label]="this.voiceInput"
  [(value)]="this.rss.botConfig.voiceInputVoiceActive"
  [colClass]="'col-3'"
  (valueChange)="this.rss.saveBotConfigField('voiceInputVoiceActive');"
>
  <app-hint i18n="@@hint-mic-usage">
    Ermöglicht Nutzereingabe über Mikrofon
  </app-hint>
</app-form-for-boolean>
<app-form-for-boolean
  [label]="this.redirectAvatar"
  [(value)]="this.rss.botConfig.switchToAvatarFromVoice"
  [colClass]="'col-3'"
  (valueChange)="this.rss.saveBotConfigField('switchToAvatarFromVoice');"
>
  <app-hint i18n="@@hint-swap-to-avatar">
    Zusätzlicher Knopf, um zum Avatar-Bot zu wechseln
  </app-hint>
</app-form-for-boolean>
<app-form-for-boolean
  [label]="this.redirectChat"
  [(value)]="this.rss.botConfig.switchToChatFromVoice"
  [colClass]="'col-3'"
  (valueChange)="this.rss.saveBotConfigField('switchToChatFromVoice');"
>
  <app-hint i18n="@@hint-swap-to-chat">
    Zusätzlicher Knopf, um zum Chat-Bot zu wechseln
  </app-hint>
</app-form-for-boolean>
<app-form-for-boolean
  [label]="this.cancelThinking"
  [(value)]="this.rss.botConfig.cancelBotThinkingChatActive"
  [colClass]="'col-3'"
  (valueChange)="this.rss.saveBotConfigField('cancelBotThinkingChatActive');"
>
  <app-hint i18n="@@hint-cancel-thinking">
    Aktuell laufende Bot-Bearbeitung abbrechen
  </app-hint>
</app-form-for-boolean>
<h3
  class="mt-5"
  i18n="@@audio-options"
>Audio</h3>
<div class="row align-items-center mb-2">
  <div class="col-3">
    <span>Model</span>
    <app-hint i18n="@@hint-choose-elevenlabs-model">
      <b>Eleven Multilingual v2</b><br>
      Der lebensechtester, emotional reichhaltigster Modus in 29 Sprachen. Am besten geeignet für Voice-Overs,
      Hörbücher, Postproduktion oder andere Anforderungen bei der Erstellung von Inhalten.
      <br><b>Eleven Flash v2.5</b><br>
      Das Modell mit extrem geringer Latenz in 32 Sprachen. Ideal für Konversationsanwendungen.
      <br><b>Eleven Turbo v2.5</b><br>
      Ein hochwertiges Modell mit geringer Latenz in 32 Sprachen. Am besten geeignet für Entwickleranwendungen,
      bei denen Geschwindigkeit eine Rolle spielt und du nicht-englische Sprachen benötigst.
    </app-hint>
  </div>
  <div class="col-auto">
    <p-select
      [options]="this.elevenLabsModelOptions"
      [(ngModel)]="this.rss.botConfig.voiceConfig.model"
      [ngModelOptions]="{updateOn: 'blur'}"
      (ngModelChange)="this.rss.saveBotConfigField('voiceConfig');"
    ></p-select>
  </div>
</div>
<app-form-for-boolean
  [label]="this.voiceBoost"
  [(value)]="this.rss.botConfig.voiceConfig.use_speaker_boost"
  [colClass]="'col-3'"
  (valueChange)="this.rss.saveBotConfigField('voiceConfig');"
>
  <app-hint i18n="@@hint-choose-boost">
    Aktivieren des Sprech Booster
  </app-hint>
</app-form-for-boolean>
<div class="row align-items-center mb-2">
  <div class="col-3">
    <span i18n="@@voice-stability">Stabilität</span>
    <app-hint i18n="@@hint-choose-stability">
      Auswahl der Stabilität
    </app-hint>
  </div>
  <div class="col lock-sensitive">
    <div class="voice-slider-container">
      <span
        class="voice-slider-label"
        i18n="@@stability-emotional"
      >Emotional</span>
      <div class="voice-slider-wrapper">
        <div
          class="voice-value-bubble"
          [style.left.%]="this.rss.botConfig.voiceConfig.stability * 100"
        >
          {{ this.rss.botConfig.voiceConfig.stability | number:'1.1-1':'de-DE' }}
        </div>
        <p-slider
          [(ngModel)]="this.rss.botConfig.voiceConfig.stability"
          [min]="0"
          [max]="1"
          [step]="0.1"
          (onSlideEnd)="this.sliderChange(($event.value ?? 0) + '', 'stability')"
        ></p-slider>
        <div class="voice-slider-scale">
          <span>0</span>
          <span>0,5</span>
          <span>1</span>
        </div>
      </div>
      <span
        class="voice-slider-label"
        i18n="@@stability-monotone"
      >Monoton</span>
    </div>
  </div>
</div>
<div class="row align-items-center mb-2">
  <div class="col-3">
    <span i18n="@@voice-similarity">Ähnlichkeit</span>
    <app-hint i18n="@@hint-choose-similarity">
      Auswahl der Ähnlichkeit zur orginalen Stimme
    </app-hint>
  </div>
  <div class="col lock-sensitive">
    <div class="voice-slider-container">
      <span
        class="voice-slider-label"
        i18n="@@similarity-weak"
      >Schwach</span>
      <div class="voice-slider-wrapper">
        <div
          class="voice-value-bubble"
          [style.left.%]="this.rss.botConfig.voiceConfig.similarity_boost * 100"
        >
          {{ this.rss.botConfig.voiceConfig.similarity_boost | number:'1.1-1':'de-DE' }}
        </div>
        <p-slider
          [(ngModel)]="this.rss.botConfig.voiceConfig.similarity_boost"
          [min]="0"
          [max]="1"
          [step]="0.1"
          (onSlideEnd)="this.sliderChange(($event.value ?? 0) + '', 'similarity_boost')"
        ></p-slider>
        <div class="voice-slider-scale">
          <span>0</span>
          <span>0,5</span>
          <span>1</span>
        </div>
      </div>
      <span
        class="voice-slider-label"
        i18n="@@similarity-strong"
      >Stark</span>
    </div>
  </div>
</div>
<div class="row align-items-center mb-2">
  <div class="col-3">
    <span i18n="@@voice-style">Stil</span>
    <app-hint i18n="@@hint-choose-style">
      Stärke des originalen Sprachstils, (Höhere Werte verursachen eine höhere Laufzeit)
    </app-hint>
  </div>
  <div class="col lock-sensitive">
    <div class="voice-slider-container">
      <span
        class="voice-slider-label"
        i18n="@@style-emotional"
      >Schwach</span>
      <div class="voice-slider-wrapper">
        <div
          class="voice-value-bubble"
          [style.left.%]="this.rss.botConfig.voiceConfig.style * 100"
        >
          {{ this.rss.botConfig.voiceConfig.style | number:'1.1-1':'de-DE' }}
        </div>
        <p-slider
          [(ngModel)]="this.rss.botConfig.voiceConfig.style"
          [min]="0"
          [max]="1"
          [step]="0.1"
          (onSlideEnd)="this.sliderChange(($event.value ?? 0) + '', 'style')"
        ></p-slider>
        <div class="voice-slider-scale">
          <span>0</span>
          <span>0,5</span>
          <span>1</span>
        </div>
      </div>
      <span
        class="voice-slider-label"
        i18n="@@style-monotone"
      >Stark</span>
    </div>
  </div>
</div>
<div class="row align-items-center mb-2">
  <div class="col-3">
    <span i18n="@@voice-speed">Sprechgeschwindigkeit</span>
    <app-hint i18n="@@hint-choose-speed">
      Auswahl der Sprechgeschwindigkeit
    </app-hint>
  </div>
  <div class="col lock-sensitive">
    <div class="voice-slider-container">
      <span
        class="voice-slider-label"
        i18n="@@speed-emotional"
      >Langsam</span>
      <div class="voice-slider-wrapper">
        <div
          class="voice-value-bubble"
          [style.left.%]="(this.rss.botConfig.voiceConfig.speed - 0.7) / 0.5 * 100"
        >
          {{ this.rss.botConfig.voiceConfig.speed | number:'1.1-1':'de-DE' }}
        </div>
        <p-slider
          [(ngModel)]="this.rss.botConfig.voiceConfig.speed"
          [min]="0.7"
          [max]="1.2"
          [step]="0.1"
          (onSlideEnd)="this.sliderChange(($event.value ?? 0) + '', 'speed')"
        ></p-slider>
        <div class="voice-slider-scale">
          <span>0,7</span>
          <span>0,95</span>
          <span>1,2</span>
        </div>
      </div>
      <span
        class="voice-slider-label"
        i18n="@@speed-monotone"
      >Schnell</span>
    </div>
  </div>
</div>
<h3 class="mt-5">
  <ng-container i18n="@@voice-selection">Stimmen-Auswahl</ng-container>
  <app-hint i18n="@@hint-voice-selection">
    Die obigen Einstellungen zur Audioausgabe beeinflussen leider nicht die Demodaten der verfügbaren Stimmen. Bitte
    dafür den Audio-Bot direkt öffnen.
  </app-hint>
</h3>
@if (this.voiceService.voices.length !== 0) {
<ul class="voice-list">
  <li
    class="voice-list-item"
    i18n="@@random-voice"
    [ngClass]="{'active': this.rss.botConfig.voiceConfig.id === 'zufällig'}"
    (click)="this.rss.botConfig.voiceConfig.id = 'zufällig'; this.rss.saveBotConfigField('voiceConfig')"
  >Zufällig</li>
  @for (voice of this.voiceService.getVoicesByModel(this.rss.botConfig.voiceConfig.model); track $index) {
  <li
    class="voice-list-item"
    [ngClass]="{'active': voice.voiceId === this.rss.botConfig.voiceConfig.id}"
  >
    <div class="row align-items-center">
      <div
        class="col cursor-pointer"
        (click)="this.rss.botConfig.voiceConfig.id = voice.voiceId; this.rss.saveBotConfigField('voiceConfig')"
      >
        <div class="voice-name">{{voice.name}}</div>
        <div class="voice-badges">
          @if (voice.labels.accent) {
          <span class="voice-badge">{{voice.labels.accent}}</span>
          }
          @if (voice.labels.age) {
          <span class="voice-badge">{{voice.labels.age}}</span>
          }
          @if (voice.labels.gender) {
          <span class="voice-badge">{{voice.labels.gender}}</span>
          }
          @if (voice.labels.description || voice.labels.descriptive) {
          <span class="voice-badge">{{voice.labels.description || voice.labels.descriptive}}</span>
          }
          @if (voice.labels.use_case) {
          <span class="voice-badge">{{voice.labels.use_case}}</span>
          }
        </div>
      </div>
      @let deData = this.voiceService.getLangByVoiceAndModel(voice.voiceId, 'de');
      @let enData = this.voiceService.getLangByVoiceAndModel(voice.voiceId, 'en');
      <div class="voice-audio-col text-center">
        @if (!deData) {
        <span class="text-secondary">-</span>
        }
        @if (deData) {
        <span
          class="language-flag"
          style="background-image: url('assets/de.svg');"
        >&nbsp;</span>
        }
        @if (deData) {
        <app-audio-btn
          i18n-msg="@@voice-demo"
          [msg]="''"
          [demoURL]="deData.previewUrl"
          [botId]="this.rss.botConfig._id"
          [isVoiceTester]="true"
          [voiceTesterIdentifier]="voice.voiceId + '_de'"
        >
        </app-audio-btn>
        }
      </div>
      <div class="voice-audio-col text-center">
        @if (!enData) {
        <span class="text-secondary">-</span>
        }
        @if (enData) {
        <span
          class="language-flag"
          style="background-image: url('assets/en.svg');"
        >&nbsp;</span>
        }
        @if (enData) {
        <app-audio-btn
          i18n-msg="@@voice-demo"
          [msg]="''"
          [demoURL]="enData.previewUrl"
          [botId]="this.rss.botConfig._id"
          [isVoiceTester]="true"
          [voiceTesterIdentifier]="voice.voiceId + '_en'"
        >
        </app-audio-btn>
        }
      </div>
      <div class="voice-audio-col text-center">
        @if (enData || deData) {
        <span class="text-secondary">-</span>
        }
        @if (!enData && !deData) {
        <app-audio-btn
          i18n-msg="@@voice-demo"
          [msg]="''"
          [demoURL]="voice.previewUrl"
          [botId]="this.rss.botConfig._id"
          [isVoiceTester]="true"
          [voiceTesterIdentifier]="voice.voiceId"
        >
        </app-audio-btn>
        }
      </div>
    </div>
  </li>
  }
</ul>
}
@if (this.voiceService.voices.length === 0) {
<span i18n="@@voices-not-available">
  Aktuell besteht eine Störung beim Abruf der verfügbaren Stimmen.
</span>
}
<h3
  class="mt-5"
  i18n="@@css-individual"
>Individueller CSS</h3>
<app-codemirror-css
  [instruction]="this.rss.botConfig.customVoiceCss"
  [rows]="13"
  [botlyContext]="'Audio-Bot'"
  [placeholder]="this.enterCustomCss"
  (finish)="this.rss.botConfig.customVoiceCss = $event; this.rss.saveBotConfigField('customVoiceCss')"
></app-codemirror-css>